import type { Cylinder } from "./movement.ts";

/** Raio e altura do colisor de estações e objetos posicionados (cliente e servidor iguais). */
export const STRUCTURE_COLLIDER = { radius: 0.6, height: 1.2 } as const;

/** O mascate é gente (doc 03): mais estreito e da altura de uma pessoa, para o golpe na cabeça contar. */
export const MASCATE_COLLIDER = { radius: 0.45, height: 1.9 } as const;

export function structureCylinder(x: number, y: number, z: number, itemId = ""): Cylinder {
  const c = itemId === "mascate" ? MASCATE_COLLIDER : STRUCTURE_COLLIDER;
  return { x, z, radius: c.radius, bottom: y - 0.5, top: y + c.height };
}

/** Ids de colisor de estruturas ficam acima dos de recursos (que vão até 2²⁸). */
export const structureColliderId = (structureId: string): number => 1073741824 + Number(structureId);
